import React, { Component, PureComponent } from "react";
import {
  Text,
  View,
  ScrollView,
  Image,
  TouchableOpacity,
  ActivityIndicator,
  Platform,
  Alert,
  Dimensions,
} from "react-native";
import * as Font from "expo-font";
import { LinearGradient } from "expo-linear-gradient";
import { Feather, AntDesign } from "@expo/vector-icons";
import { SvgCss } from "react-native-svg";
import firebase from "firebase";
import "firebase/firestore";
import distance from "../../../shared/distances";
import Moment from "react-moment";


import * as Find from "../../Find/findFunctions";
import Post from "../../Post/Post";

const SCREEN_HEIGHT = Dimensions.get("window").height;
const SCREEN_WIDTH = Dimensions.get("window").width;

const pencilIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="77.849" height="77.849" viewBox="0 0 77.849 77.849"><defs><style>.a{fill:#f4f1f1;}.b{fill:#e7dfdd;}.c{fill:#38336b;}.d{fill:#90d960;}.e{fill:#ffda2c;}.f{fill:#febf00;}.g{fill:#d20041;}.h{fill:#ba003a;}</style></defs><path class="a" d="M425.522,372.708l-2.658-7.342H412.97l-2.657,7.342a2.281,2.281,0,0,0,.072,1.728l5.46,11.9a2.281,2.281,0,0,0,4.146,0l5.46-11.9A2.281,2.281,0,0,0,425.522,372.708Z" transform="translate(-347.81 -309.813)"/><path class="b" d="M468.695,372.708l-2.657-7.342H461.09v22.3a2.281,2.281,0,0,0,2.073-1.329l5.46-11.9A2.281,2.281,0,0,0,468.695,372.708Z" transform="translate(-390.982 -309.813)"/><path class="a" d="M55.654,0H2.281A2.281,2.281,0,0,0,0,2.281V75.568a2.281,2.281,0,0,0,2.281,2.281H55.654a2.281,2.281,0,0,0,2.281-2.281V2.281A2.281,2.281,0,0,0,55.654,0Z"/><g transform="translate(28.968)"><path class="b" d="M217.2,0H190.515V77.849H217.2a2.281,2.281,0,0,0,2.281-2.281V2.281A2.281,2.281,0,0,0,217.2,0Z" transform="translate(-190.515)"/></g><g transform="translate(33.929 17.285)"><path class="c" d="M239.908,118.24H225.424a2.281,2.281,0,1,1,0-4.561h14.484a2.281,2.281,0,1,1,0,4.561Z" transform="translate(-223.143 -113.679)"/><g transform="translate(0 13.837)"><path class="c" d="M239.908,209.245H225.424a2.281,2.281,0,1,1,0-4.561h14.484a2.281,2.281,0,1,1,0,4.561Z" transform="translate(-223.143 -204.684)"/></g><g transform="translate(0 27.674)"><path class="c" d="M239.908,300.249H225.424a2.281,2.281,0,1,1,0-4.561h14.484a2.281,2.281,0,1,1,0,4.561Z" transform="translate(-223.143 -295.688)"/></g><g transform="translate(0 42.041)"><path class="c" d="M239.908,394.739H225.424a2.281,2.281,0,1,1,0-4.561h14.484a2.281,2.281,0,1,1,0,4.561Z" transform="translate(-223.143 -390.178)"/></g></g><g transform="translate(7.273 13.08)"><path class="d" d="M53.381,97.516a2.279,2.279,0,0,1-1.613-.668L48.5,93.583a2.281,2.281,0,0,1,3.225-3.225l1.652,1.652L58.7,86.695a2.281,2.281,0,0,1,3.225,3.225l-6.928,6.928A2.28,2.28,0,0,1,53.381,97.516Z" transform="translate(-47.835 -86.026)"/><g transform="translate(0 13.837)"><path class="d" d="M53.381,188.521a2.28,2.28,0,0,1-1.613-.668L48.5,184.588a2.281,2.281,0,0,1,3.225-3.225l1.652,1.652L58.7,177.7a2.281,2.281,0,0,1,3.225,3.225l-6.928,6.928A2.281,2.281,0,0,1,53.381,188.521Z" transform="translate(-47.835 -177.032)"/></g><g transform="translate(0 27.674)"><path class="d" d="M53.381,279.525a2.279,2.279,0,0,1-1.613-.668L48.5,275.592a2.281,2.281,0,0,1,3.225-3.225l1.652,1.652L58.7,268.7a2.281,2.281,0,0,1,3.225,3.225l-6.928,6.928A2.28,2.28,0,0,1,53.381,279.525Z" transform="translate(-47.835 -268.036)"/></g></g><path class="e" d="M425.662,7.741V55.27a2.281,2.281,0,0,1-2.281,2.281h-10.92a2.28,2.28,0,0,1-2.281-2.281V7.741a7.741,7.741,0,0,1,15.482,0Z" transform="translate(-347.813 0)"/><path class="f" d="M461.09,0V57.55h5.46a2.281,2.281,0,0,0,2.281-2.281V7.741A7.75,7.75,0,0,0,461.09,0Z" transform="translate(-390.982)"/><g transform="translate(62.367 14.431)"><path class="g" d="M410.18,94.91h15.482v4.561H410.18Z" transform="translate(-410.18 -94.91)"/></g><path class="h" d="M461.09,94.91h7.741v4.561H461.09Z" transform="translate(-390.982 -80.479)"/></svg>`;

// const LikeIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="60" viewBox="0 0 60 60"><defs><style>.a{fill:#fff;}.b{fill:red;stroke:#707070;}.c{filter:url(#a);}</style><filter id="a" x="0" y="0" width="60" height="60" filterUnits="userSpaceOnUse"><feOffset dy="3" input="SourceAlpha"/><feGaussianBlur stdDeviation="5" result="b"/><feFlood flood-opacity="0.149"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(15 12)"><g class="c" transform="matrix(1, 0, 0, 1, -15, -12)"><rect class="a" width="30" height="30" rx="8" transform="translate(15 12)"/></g><path class="b" d="M6.786,12.075a.8.8,0,0,1-.525-.2c-.548-.479-1.077-.93-1.543-1.327l0,0a28.7,28.7,0,0,1-3.37-3.163A5.052,5.052,0,0,1,0,4.079a4.242,4.242,0,0,1,1.077-2.9A3.65,3.65,0,0,1,3.791,0,3.414,3.414,0,0,1,5.924.736a4.363,4.363,0,0,1,.862.9,4.363,4.363,0,0,1,.862-.9A3.414,3.414,0,0,1,9.78,0,3.65,3.65,0,0,1,12.5,1.182a4.242,4.242,0,0,1,1.077,2.9,5.051,5.051,0,0,1-1.346,3.306,28.7,28.7,0,0,1-3.369,3.163c-.467.4-1,.849-1.546,1.33A.8.8,0,0,1,6.786,12.075ZM3.791.8a2.863,2.863,0,0,0-2.13.925A3.451,3.451,0,0,0,.795,4.079a4.25,4.25,0,0,0,1.163,2.8A28.244,28.244,0,0,0,5.231,9.943l0,0c.468.4,1,.851,1.551,1.334.556-.484,1.087-.937,1.556-1.336a28.249,28.249,0,0,0,3.273-3.065,4.251,4.251,0,0,0,1.163-2.8,3.451,3.451,0,0,0-.866-2.358A2.863,2.863,0,0,0,9.78.8a2.637,2.637,0,0,0-1.646.57,3.858,3.858,0,0,0-.917,1.062.5.5,0,0,1-.862,0,3.854,3.854,0,0,0-.917-1.062A2.637,2.637,0,0,0,3.791.8Zm0,0" transform="translate(8 9)"/></g></svg>`;

export default class JobsPreview extends Component {
  state = {
    selectedItem: null,
    secondRow: [],
    showDetail: false,
    detailPostResult: null,
    randomString: "",
    aaLike: false,
    moreToShow: false,
    loading: true,
  };

  constructor() {
    super();
    const firestore = firebase.firestore();
    this.unsubscribeFirestore = () => {
      return;
    };
    this.listOfJobCategories = [
      "Sales and Marketing",
      "Physical Workmanship",
      "Technical, IT",
      "Creatives, Design, DJ, Entertainer",
      "Waiters, Hostesses, Representatives",
      "Teaching, Nanny, Nursing",
      "Household, Cooking, Errands",
      "Office and Admin",
      "Extra Cash",
      "Other",
    ];
  }

  async componentDidMount() {
    try {
      if (!global.myUID)
        await global.timeout(500)
      if (!global.myUID)
        await global.timeout(500)
      if (!global.myUID)
        await global.timeout(500)
      if (!global.myUID)
        await global.timeout(500)
      if (!global.myUID)
        await global.timeout(500)
      if (!global.myUID)
        await global.timeout(500)
      if (!global.myUID)
        await global.timeout(500)
      if (!global.myUID)
        await global.timeout(500)
      if (!global.myUID)
        await new global.timeout(500)
      if (!global.myUID)
        await new global.timeout(2500)

      this.loadContent()

      //console.log("Results from findOffersAsync", re)
    } catch (e) {
      console.warn("Error 923432");
      console.log(" Error 923432", e);
    }
  }
  componentWillUnmount() {
    this.unsubscribeFirestore();
  }

  async loadContent(theAmount) {
    const amount = theAmount || 4
    try {
      this.setState({ loading: true })
      await global.setLocationFast(10);

      const re = await Find.findPostOffersAsync({
        orderBy: "RECENTNEARBY",
        category1: "QuickJobs",
        category2: this.state.selectedItem || null,
        location: global.location || { coords: { latitude: 6.6, longitude: 3.3 } },
        amount,
      })
      // const searchTerm = this.state.selectedItem ? this.state.selectedItem.toLowerCase().replace(/[^a-zA-Z]/g, "") : ""
      // const re = await Find.findOffersAsync({
      //   searchTerm: searchTerm || "QuickJobs",
      //   location: global.location || {
      //     coords: { latitude: 6.6, longitude: 3.3 },
      //   },
      //   amount: 30,
      // });
      if (re == -1) return this.setState({ error: "Error loading offers." });
      if (Array.isArray(re) && re.length >= amount) {
        re.length = amount;
        this.setState({ moreToShow: true })
      } else this.setState({ moreToShow: false })
      if (Array.isArray(re)) this.setState({ secondRow: re, loading: false });

      //console.log("Results from findOffersAsync", re)
    } catch (e) {
      console.warn("Error 9432");
      console.log(" Error 9432", e);
    }
  }
  likePost = async (isLike, postID) => {
    if (this.state.aaLike) return;
    console.log("Starting to call likePost");
    try {
      this.setState({ aaLike: true });
      if (isLike) {
        global.myLikedPostIDs.push(postID);
        global.myDislikedPostIDs = global.myDislikedPostIDs.filter((id) => {
          return id != postID;
        });
      } else {
        global.myDislikedPostIDs.push(postID);
        global.myLikedPostIDs = global.myLikedPostIDs.filter((id) => {
          return id != postID;
        });
      }
      this.setState({
        randomString: "-" + Math.floor(Math.random() * 9999999999),
      });
      const r = await fetch(global.cloudFunctionURL + "likePost", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ isWeb:true,
          action: isLike ? "like" : "unlike",
          postID: postID,
          myUID: global.myUID,
          idToken: global.idToken,
        }),
      });
      const r2 = await r.json();

      console.log("Received response. ", r2.msg);
      this.setState({ aaLike: false });
      if (r2.msg === "SUCCESS") {
        //
      } else {
        // revert setting global
        if (!isLike) {
          global.myLikedPostIDs.push(postID);
          global.myDislikedPostIDs = global.myDislikedPostIDs.filter((id) => {
            return id != postID;
          });
        } else {
          global.myDislikedPostIDs.push(postID);
          global.myLikedPostIDs = global.myLikedPostIDs.filter((id) => {
            return id != postID;
          });
        }
      }
    } catch (e2) {
      console.warn("ERROR u6");
      console.log("ERROR u6", e2);
      this.setState({ aaLike: false });
    }
  };

  renderSlider = () => {
    return (
      <ScrollView
        horizontal={true}
        showsHorizontalScrollIndicator={false}
      >
        {this.listOfJobCategories.map((item, i) => {
          let r = (i + 1) * 200
          let g = (i + 1) * 30
          let b = (i + 1) * 300
          while (r > 128) r -= 128
          while (g > 128) g -= 128
          while (b > 128) b -= 128
          return (
            <TouchableOpacity
              key={item}
              style={{
                backgroundColor: "rgb(" + r + "," + g + "," + b + ")",
                height: 85,
                width: 85,
                borderRadius: 6,
                alignItems: "center",
                justifyContent: "center",
                marginVertical: 5,
                marginBottom: 10,
                marginHorizontal: 5,
                borderWidth: item == this.state.selectedItem ? 3 : 0,
                borderColor: "white"
                // margingRight: 10
              }}
              onPress={async () => {
                if (this.state.selectedItem == item) {
                  await this.setState({ selectedItem: null })
                  global.reportStats("pressed_Jobs_Category2", "Unselect")
                }
                else {
                  await this.setState({ selectedItem: item })
                  global.reportStats("pressed_Jobs_Category2", item)
                }
                this.loadContent()
              }}
            >
              <Text
                style={{
                  color: "white",
                  textAlign: "center",
                  fontSize: 13
                }}
              >
                {item}
              </Text>
            </TouchableOpacity>
          );
        })}
      </ScrollView>
    )
  }

  render() {
    if (this.state.loading)
      return (
        <View
          style={{
            height: 200,
            width: "100%",
            paddingLeft: 10,
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 100
          }}
        >
          {this.renderSlider()}
          <View style={{ height: 30, flexDirection: "row", justifyContent: "center", alignItems: "center", width: "100%" }}>
            <ActivityIndicator size="small" color="#999" />
            <Text style={{ color: "#999", marginLeft: 8 }}>Loading Jobs</Text>
          </View>
        </View>
      );
    return (
      <View>
        <View
          style={{
            // top: 50,
            flexDirection: "column",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: 10,
            alignSelf: "center",
          }}
        >
          {this.renderSlider()}

          {this.state.secondRow.map((item, i) => {
            const result = item;
            let pString = Math.round(result.p).toString();
            if (pString.length > 8) {
              pString = pString.slice(0, pString.length - 6) + "M";
            } else if (pString.length > 6) {
              pString = Number(pString.slice(0, pString.length - 5)) / 10;
              pString = pString.toString() + "M";
            } else if (pString.length > 4) {
              pString = pString.slice(0, pString.length - 3) + "K";
            }

            let pCurrency = result.pc || "NGN";
            let pCurrencyString = global.currencySymbols[pCurrency];

            let priceString = pCurrencyString + " " + pString;

            //localString is acnString
            let localString = "";
            // xx possibly remove NGN from last section of the following line  to show less
            // xx possibly replace last section of the following line with global.xRates[post.postPriceCurrency||"NGN"] to show ACN for all (also old) NGN posts
            if (
              global.walletType == "ACN" &&
              !(result.pc == "ACN") &&
              result.pt != "Free" &&
              result.p > 0 &&
              global.xRates[result.pc || "NGN"]
            ) {
              const lPrice = Math.round(
                result.p / global.xRates[result.pc || "NGN"]
              );
              const lCurrency = global.currencySymbols["ACN"];
              let lString = Math.round(lPrice).toLocaleString(0);
              localString = "≈ " + lCurrency + " " + lString;
            }
            let beforeString = "";
            let afterString = "";
            if (result.pt && result.pt != "Fixed Price") {
              if (result.pt == "Starting From") {
                beforeString = "Starting From";
              } else {
                afterString = "(" + result.pt + ")";
              }
              if (result.pt == "Free") {
                priceString = "FREE";
                localString = "";
                afterString = "";
              }
              if (result.pt == "NONE") {
                priceString = "";
                localString = "";
                afterString = "";
              }
            }

            let milliseconds = 0
            let timeCreated = 0
            if (result.timeCreated) {
              milliseconds = result.timeCreated._seconds ? result.timeCreated._seconds * 1000 + result.timeCreated._nanoseconds / 1000000 : result.timeCreated.seconds * 1000 + result.timeCreated.nanoseconds / 1000000
              timeCreated = new Date(milliseconds)
            }

            let isLiked = false;
            if (
              global.myLikedPostIDs &&
              global.myLikedPostIDs.includes(item.xID)
            )
              isLiked = true;

            return (
              <View key={"P" + result.xID} style={{ alignSelf: "stretch", paddingRight: 5 }}>
                <TouchableOpacity
                  onPress={() => {
                    this.setState({ showDetail: true, detailPostResult: result })
                  }}
                  style={{
                    flexDirection: "row", height: 92, borderBottomWidth: 0, borderBottomColor: "#606072",
                    alignItems: "center", alignSelf: "stretch", justifyContent: "space-between",
                    margin: 6, borderRadius: 6, backgroundColor: "#242424", paddingHorizontal: 7,
                  }}>
                  <View style={{ width: 70, marginRight: 2 }}>
                    {!!result.url && (<View>
                      <Image
                        style={{
                          width: 70,
                          height: 70,
                          paddingRight: 8,
                          borderRadius: 8.5
                        }}
                        source={{
                          uri: result.url
                        }}
                      />
                      {!!result.authorURL && <Image
                        style={{
                          marginTop: -69,
                          width: 30,
                          height: 30,
                          marginLeft: 1,
                          marginBottom: 54,
                          borderRadius: 15,
                          borderWidth: 1,
                          borderColor: "#ccd",
                        }}
                        source={{ uri: result.authorURL }}
                      />}

                    </View>
                    )}
                  </View>
                  <View
                    style={{
                      flex: 1,
                      height: 92,
                      justifyContent: "space-between",
                      paddingHorizontal: 8
                    }}
                  >
                    <View style={{ marginTop: 8 }}>
                      <Text numberOfLines={2} style={[{ fontSize: 14, letterSpacing: 0.36, color: "#fff", fontWeight: "bold" }]}>
                        {result.t}
                      </Text>
                    </View>
                    <View style={{ marginBottom: 8 }}>
                      {beforeString != "" && <Text style={[{ fontSize: 10, color: "#ccccd5" }]}>
                        {beforeString}
                      </Text>}
                      <Text style={[{
                        fontSize: 16,
                        fontWeight: "bold",
                        letterSpacing: 0.48,
                        textAlign: "left",
                        color: "#A8CF45",
                        opacity: 0.8
                      }]}>
                        {priceString}
                      </Text>
                      {localString != "" && <Text style={[{
                        fontSize: 12,
                        fontWeight: "bold",
                        letterSpacing: 0.48,
                        textAlign: "left",
                        color: "#A8CF45",
                        opacity: 0.8
                      }]}>
                        {localString}
                      </Text>}
                      {!!afterString && <Text style={[{ fontSize: 10, fontWeight: "500", color: "#ccccd5" }]}>{afterString}</Text>}
                    </View>
                  </View>
                  <View
                    style={{ width: 80, alignItems: "flex-end", justifyContent: "center" }}
                  >
                    {!!timeCreated && (
                      <View style={{ justifyContent: "flex-end", alignItems: "center", flexDirection: "row", marginBottom: 50 }} >
                        <Text style={{ fontSize: 10, color: "#aaaab3", fontWeight: "500" }}>
                          <Moment fromNow element={Text}>
                            {timeCreated.getTime()}
                          </Moment>
                        </Text>
                      </View>)}
                    {!!global.location && result.loc && result.loc._latitude != 6.6 && (
                      <View
                        style={{ justifyContent: "flex-end", alignItems: "center", flexDirection: "row" }}
                      >
                        <Image
                          style={{ width: 15, height: 16.5, marginRight: 4, tintColor: "#aaaab3" }}
                          source={require("../../../images/icons/Location.png")}
                        />
                        <Text style={{ fontSize: 10, color: "#aaaab3", fontWeight: "500" }}>
                          {Math.round(distance(result.loc._latitude, result.loc._longitude, global.location.coords.latitude, global.location.coords.longitude, "K"
                          ) * 1) / 1 + " km"}
                        </Text>
                      </View>)}
                  </View>
                </TouchableOpacity>
                {this.state.showDetail && (
                  <Post
                    postID={this.state.detailPostResult.xID}
                    postResult={this.state.detailPostResult}
                    //data={this.props.data}
                    key={this.state.detailPostResult.xID + this.state.showDetail}
                    navigation={this.props.navigation}
                    showDetail={this.state.showDetail}
                    onHideDetail={() => {
                      this.setState({ showDetail: false });
                    }}
                    relevantStatus={"LIVE"}
                    blackBackground={true}
                    onIsNotRelevant={() => {
                      alert("Offer not available at the moment");
                    }}
                  />
                )}
              </View>
            )
          })}
          {(this.state.moreToShow) && <TouchableOpacity
            onPress={() => {
              this.loadContent(100)
              global.reportStats("pressed_Jobs_QuickJobsSeeMore")
            }}
            style={{ alignSelf: "flex-end", marginRight: 10 }}
          >
            <Text
              style={{
                color: "#A9D046",
                fontWeight: "bold",
                marginTop: 4,
                marginBottom: 8,
                fontSize: 18,
                fontFamily: "ProximaNovaA-Bold",
              }}
            >
              See More
                  </Text>
          </TouchableOpacity>}
        </View>
      </View>
    );
  }
}
